import { useEffect, useState } from "react";

/**
 * Floating "back to top" button at the bottom-right corner of the
 * viewport. Becomes visible once the user has scrolled more than
 * 480 px down. Smooth scrolls back to the top on click.
 */
export function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Nach oben scrollen"
      title="Nach oben"
      className="fixed bottom-6 right-6 z-50 w-11 h-11 rounded-full text-white shadow-lift flex items-center justify-center transition-colors"
      style={{ background: "var(--color-primary-hover)" }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#0F2418")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "var(--color-primary-hover)")}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M6 14l6-6 6 6" />
      </svg>
    </button>
  );
}
